import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { useEffect, useState } from 'react';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useRouter } from 'next/router';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';

interface ItemType {
    img?: string;
    title: string;
    label?: string;
    link: string;
    desc?: string[];
    price?: number;
    compareAtPrice?: number;
    productId?: string;
    variantId?: string;
    inventory?: number;
}
export default function E() {
    const { t } = useLang('bkw');
    const { locale = 'de' } = useRouter();
    const [gap, setGap] = useState<number>(16);
    const items_static: ItemType[] = [
        {
            label: t('E_item1_label'),
            title: t('E_item1_title'),
            desc: [t('E_item1_desc1'), t('E_item1_desc2')],
            productId: '14953711993213',
            variantId: '55153031086461',
            link: 'https://de.ecoflow.com/products/balkonkraftwerk-800w-450w-starres-solarpanel?variant=55153031086461',
        },
        {
            label: t('E_item2_label'),
            title: t('E_item2_title'),
            desc: [t('E_item2_desc1'), t('E_item2_desc2')],
            productId: '8632225136975',
            variantId: '48115249938767',
            link: 'https://de.ecoflow.com/products/balkonkraftwerk-600w-800w-400w-starres-solarpanel?variant=48115249938767',
        },
        {
            title: t('E_item3_title'),
            link: 'https://de.ecoflow.com/pages/powerstream?tab=diy',
        },
    ];
    const [items, setItems] = useState<ItemType[]>(items_static);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(items_static?.filter((item: any) => item?.productId && item?.variantId)));
        const restArr = JSON.parse(JSON.stringify(items_static?.filter((item: any) => !item?.productId && !item?.variantId)));
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].price = res?.data?.price;
                        tempArr[k].compareAtPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].inventory = res?.data?.inventoryQuantity ?? 0;
                        tempArr[k].img = res?.data?.variantImg || '';
                        // tempArr[k].title = res?.data?.productTitle || res?.data?.skuTitle || '';
                        // tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setItems(JSON.parse(JSON.stringify([...tempArr, ...restArr])));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 1024) {
                setGap(16);
            } else {
                setGap(24);
            }
        }
    }, []);

    return (
        <div id="bkw-E" className={`bkw-E bkw-box inner ${css['bkw-E']}`}>
            <EfSpec />
            <div className="info">
                <h3 className="title title-s">{t('E_title')}</h3>
            </div>
            <Swiper
                className="items"
                modules={[Navigation]}
                spaceBetween={gap}
                // centeredSlides={gap !== 16}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation
                // pagination={{ clickable: true }}
            >
                {items?.map((item: ItemType, k: number) => (
                    <SwiperSlide className={`item item-${k + 1}`} key={k}>
                        {item?.img && (
                            <div className="item-img">
                                <EfImg pc={item.img} />
                                {item?.label && <span className="item-label">{item.label}</span>}
                            </div>
                        )}
                        <div className="item-info">
                            <p className="item-title">{item.title}</p>
                            {item?.desc && item?.desc?.length > 0 && (
                                <ul className="item-lists">
                                    {item?.desc?.map((desc: string, m: number) => (
                                        <li className="item-desc" key={`${k}_${m}`}>
                                            {desc}
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {item?.price && (
                                <div className="item-price">
                                    <span className="price">{FormatMoneyLocal(item?.price, locale)}</span>
                                    {item?.compareAtPrice && item?.compareAtPrice !== item.price && (
                                        <span className="compareAtPrice">{FormatMoneyLocal(item.compareAtPrice, locale)}</span>
                                    )}
                                </div>
                            )}
                            <EfLink
                                className="item-link"
                                href={item.link}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'buy',
                                    product_name: k === items?.length - 1 ? t('E_title') : item.title,
                                    position: `Scene Page_1_${k === items?.length - 1 ? 'Custom' : 'Buy'} Now`,
                                }}
                            >
                                {k === items?.length - 1 ? (
                                    <>
                                        <span className="link-text">{t('Common_custom')}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                            <path
                                                d="M9.83301 6L15.833 12L9.83301 18"
                                                stroke="currentColor"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </>
                                ) : (
                                    t('Common_buy')
                                )}
                            </EfLink>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
